// client/src/components/shell/PfTabBar.js
//
// The bottom nav for team-detail screens. 3 tabs:
//   Schedule → /teams/:teamId/schedule
//   Team     → /teams/:teamId/team
//   Practice → /teams/:teamId/practice
//
// Uses React Router's <NavLink> so active state comes from the URL.
// If someone deep-links to /teams/abc/practice, Practice tab lights
// up automatically. No local state, no context, just URL truth.
//
// Height stays in lockstep with PfShell's pb-[110px]. Change one,
// change both.
//
// Text-only labels for now. Icons deferred — chrome should feel
// calm, and the mischief lives inside screens, not around them.

import { NavLink } from 'react-router-dom';

const TABS = [
  { path: 'schedule', label: 'Schedule' },
  { path: 'team',     label: 'Team' },
  { path: 'practice', label: 'Practice' },
];

export function PfTabBar({ teamId, className = '' }) {
  return (
    // Bottom-pinned nav inside PfShell's relative frame. The frame's
    // pb-[110px] reserves this space. bg-paper + top border matches
    // TopBar's treatment on the other end.
    <nav
      className={[
        'absolute bottom-0 left-0 right-0 h-[110px]',
        'bg-paper border-t border-rule',
        'flex items-stretch',
        // pb-6 reserves iOS safe-area / home-indicator space.
        // Tabs sit above that band.
        'pb-6',
        className,
      ].join(' ')}
    >
      {TABS.map(({ path, label }) => (
        <NavLink
          key={path}
          to={`/teams/${teamId}/${path}`}
          className={({ isActive }) =>
            [
              // Each tab claims equal width.
              'flex-1 flex items-center justify-center',
              // Font: Manrope semibold, tab size (10px, tracked).
              'font-sans font-semibold uppercase',
              'text-tab',
              // Active vs inactive states.
              isActive
                ? 'text-accentDeep border-t-2 border-accent -mt-px'
                : 'text-inkSub border-t-2 border-transparent',
              // Interaction affordance.
              'transition-colors duration-150',
              'hover:text-ink',
            ].join(' ')
          }
        >
          {label}
        </NavLink>
      ))}
    </nav>
  );
}